import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { formikFieldShape, formikFormShape } from '../prop-types';

const PrimeReactErrorMessage = ({ msg }) => (
  <Message severity="error" text={msg} />
);

PrimeReactErrorMessage.propTypes = {
  msg: PropTypes.string.isRequired,
};

const CopyAddOn = ({ keyValue }) => (
  <CopyToClipboard text={keyValue}>
    <Button type="button" icon="pi pi-clone" className="p-button-secondary" />
  </CopyToClipboard>
);

CopyAddOn.propTypes = {
  keyValue: PropTypes.string.isRequired,
};

class FormikTextCopiable extends Component {
  render() {
    const {
      field,
      keyValue,
      form: { touched, errors },
      ...props
    } = this.props;
    const displayError = touched[field.name] && errors[field.name];
    return (
      <div className="p-inputgroup">
        <InputText
          {...field}
          {...props}
          className={displayError ? 'p-error' : ''}
          style={{ marginRight: '.25em' }}
        />
        <CopyAddOn keyValue={keyValue} />

        <ErrorMessage
          name={field.name}
          render={msg => (<PrimeReactErrorMessage msg={msg} />)}
        />
      </div>
    );
  }
}

FormikTextCopiable.propTypes = {
  field: formikFieldShape.isRequired,
  form: formikFormShape.isRequired,
  keyValue: PropTypes.string.isRequired,
};

export default FormikTextCopiable;
